export default __webpack_public_path__ + "static/media/mysql.76882caa.png";